// Jersey numbers are identifiers, not quantities: preserve 0 and 00.
export function normalizeJerseyNumber(value) {
  if (typeof value !== 'string' && typeof value !== 'number') return '';
  const text = String(value).trim().replace(/^#\s*/, '');
  return /^\d{1,3}$/.test(text) ? text : '';
}

export function readPlayerJersey(player) {
  const keys = new Set(['jersey', 'jerseynumber', 'jerseyno', 'uniform', 'uniformnumber', 'uniformno', 'playernumber', 'number', 'no', '#']);
  for (const source of [player, player?.player, player?.athlete]) {
    if (!source || typeof source !== 'object') continue;
    for (const [key, value] of Object.entries(source)) {
      if (!keys.has(key.toLowerCase().replace(/[\s_.-]/g, ''))) continue;
      const jersey = normalizeJerseyNumber(value);
      if (jersey !== '') return jersey;
    }
  }
  return '';
}
